import userResources from "api/userResources";
import SubmitButton from "components/SubmitButton/SubmitButton";
import React, { useEffect, useRef, useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { toast } from "react-toastify";

export default function UpdatePassword({ userId, onClose }) {
  const dialogRef = useRef(null);
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    if (password !== passwordConfirmation) {
      setError("Passwords do not match");
      return;
    }
    setError("");
    toast.info("Updating password...");
    try {
      await userResources.superAdminUpdatePassord({
        id: userId,
        password,
        password_confirmation: passwordConfirmation,
      });
      toast.success("Password updated successfully");
      dialogRef.current.close();
      onClose();
    } catch (error) {
      toast.error("Failed to update password");
      setError("Failed to update password");
    }
  };

  useEffect(() => {
    if (dialogRef.current) {
      dialogRef.current.showModal();
    }
  }, []);

  return (
    <dialog ref={dialogRef} className="modal">
      <div className="modal-box rounded-lg bg-white py-5 text-gray-900 dark:bg-gray-900 dark:text-white">
        <form method="dialog">
          <button
            className="btn btn-circle btn-ghost btn-sm absolute right-2 top-2 text-red-600"
            onClick={() => {
              dialogRef.current.close();
              onClose();
            }}
          >
            ✕
          </button>
        </form>
        <h2 className="mb-4 text-xl font-semibold dark:text-[#bb8e25]">
          Update Password
        </h2>
        <form onSubmit={handleUpdatePassword}>
          <div className="relative mb-4">
            <label className="block text-sm font-medium dark:text-[#bb8e25]">
              New Password
            </label>
            <input
              type={showPassword ? "text" : "password"}
              className="w-full rounded border bg-white p-2 dark:bg-transparent"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <span
              className="absolute right-3 top-9 cursor-pointer"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          <div className="relative mb-4">
            <label className="block text-sm font-medium dark:text-[#bb8e25]">
              Confirm Password
            </label>
            <input
              type={showConfirmPassword ? "text" : "password"}
              className="w-full rounded border bg-white p-2 dark:bg-transparent"
              value={passwordConfirmation}
              onChange={(e) => setPasswordConfirmation(e.target.value)}
              required
            />
            <span
              className="absolute right-3 top-9 cursor-pointer"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            >
              {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          {error && <p className="mb-2 text-sm text-red-600">{error}</p>}
          <SubmitButton
            add="Update Password"
            extraClass="btn w-full border-0"
          />
        </form>
      </div>
    </dialog>
  );
}
